'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _container = require('../../helpers/container');

var _container2 = _interopRequireDefault(_container);

var _components = require('../../components');

var _EduCenterPlanAdmins = require('./EduCenterPlanAdmins.css');

var _EduCenterPlanAdmins2 = _interopRequireDefault(_EduCenterPlanAdmins);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EduCenterPlanAdmins = (_dec = (0, _reactCssModules2.default)(_EduCenterPlanAdmins2.default, { allowMultiple: true }), _dec(_class = function (_Component) {
  (0, _inherits3.default)(EduCenterPlanAdmins, _Component);

  function EduCenterPlanAdmins(props) {
    (0, _classCallCheck3.default)(this, EduCenterPlanAdmins);

    var _this = (0, _possibleConstructorReturn3.default)(this, (EduCenterPlanAdmins.__proto__ || (0, _getPrototypeOf2.default)(EduCenterPlanAdmins)).call(this, props));

    _this.state = {
      title: 'If you\'re a company 401(k) plan administrator',
      description: 'Resources for administrators of employer-offered retirement plans to take action to make their plan more sustainable.',
      url: _config2.default.domain + _config2.default.routes.eduCenterPlanAdmins
    };
    return _this;
  }

  (0, _createClass3.default)(EduCenterPlanAdmins, [{
    key: 'render',
    value: function render() {
      var img1 = require('../../../static/images/millenial_employees.jpg');
      //
      return _react2.default.createElement(
        'div',
        { styleName: 'page' },
        _container2.default.helmet(this.state.title, this.state.description, this.state.url),
        _react2.default.createElement(
          _components.ContainerDivs,
          null,
          _react2.default.createElement(
            'div',
            { styleName: 'small-page-title' },
            this.state.title
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'copy' },
            _react2.default.createElement(
              'h2',
              null,
              'What are the company benefits of making a 401(k) plan more sustainable?'
            ),
            _react2.default.createElement(
              'h3',
              null,
              'Attract top talent and spur engagement'
            ),
            _react2.default.createElement(
              'p',
              null,
              'As millennial-aged employees now represent the majority of the U.S. workforce, it is increasingly important that management finds ways to engage them in the company. ',
              _react2.default.createElement(
                _components.Link,
                { to: 'https://www.morganstanley.com/pub/content/dam/msdotcom/ideas/sustainable-signals/pdf/Sustainable_Signals_Whitepaper.pdf', title: 'Sustainable Signals: New Data from the Individual Investor - Morgan Stanley', xstrong: true },
                'A recent Morgan Stanley study found'
              ),
              ' that 90% of millennials want sustainable investments as an option within their 401(k) plans. The study also found that 75% of millennials believe that their investments can influence climate change, and 84% believe that their investments have the power to help lift people out of poverty. Providing employees with the investment options which connect to their core values \u2013 like solving human, social and environmental problems through their work and investments \u2013 can attract top talent to companies and spur employee engagement.'
            ),
            _react2.default.createElement(
              'h3',
              null,
              'Increase employee retention and company buy-in'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Creating an environment where employees feel empowered to contribute to the greater good has been proven to increase employee retention and company buy-in. In fact, 67% of millennials would be more likely to contribute, or increase their plan contributions, ',
              _react2.default.createElement(
                _components.Link,
                { to: 'https://www.nytimes.com/2019/09/27/business/esg-401k-investing-retirement.html', title: 'Bit by Bit, Socially Conscious Investors Are Influencing 401(k)\u2019s - New York Times', xstrong: true },
                'if they knew their investments were contributing to social good.'
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'img-blockquote' },
              _react2.default.createElement('img', {
                src: img1,
                alt: '90% of millennials want sustainable investments as an option within their 401(k) plans, and 75% of millennials believe that their investments can influence climate change.'
              }),
              _react2.default.createElement(
                'blockquote',
                null,
                '90% of millennials want sustainable investments as an option within their 401(k) plans, and 75% of millennials believe that their investments can influence climate change.'
              )
            ),
            _react2.default.createElement(
              'h3',
              null,
              'Align with corporate sustainability commitments'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Companies are making increasingly bold commitments to decarbonization and prioritizing environmental and social sustainability in company operations and hiring. But if the retirement plan is investing employee savings unsustainably, this is a contradiction to those company commitments. As investors and stakeholders call for more action on climate change and social justice, this contradiction could become a reputational risk for the company.'
            ),
            _react2.default.createElement(
              'h3',
              null,
              'Become an industry leader'
            ),
            _react2.default.createElement(
              'p',
              null,
              'As the demand for ESG investing continues to rise in popularity, employees across the country are discovering their power to align their values with their retirement plans investments. A bright light is now shining on retirement investments that have been hidden for over a century. Companies now have the opportunity to become leaders in the movement and demonstrate their support for the transition to an economy that is based on justice and sustainability'
            ),
            _react2.default.createElement(
              'h2',
              null,
              'What are the solutions?'
            ),
            _react2.default.createElement(_components.SolutionsList, null),
            _react2.default.createElement(
              'h2',
              null,
              'Plan administrator FAQs'
            ),
            _react2.default.createElement(
              'h3',
              null,
              'Is offering ESG funds in a defined contribution plan allowed under DOL rules?'
            ),
            _react2.default.createElement(
              'p',
              null,
              'While demand across the world for ESG investments has seen a dramatic spike in recent years, in 2020 the Trump Administration\u2019s DOL (Department of Labor) attempted to constrain this growth by issuing a new rule which aims to limit how ESG investments can be considered in retirement plans. After hearing from labor organizations and asset managers across the country, the Biden Administration\u2019s DOL stated they will revisit the rule, and until then, ',
              _react2.default.createElement(
                _components.Link,
                { to: 'https://www.cnbc.com/2021/03/11/biden-admin-making-it-easier-to-invest-in-esg-funds-in-401k-plans.html', title: 'The Department of Labor is making it easier to invest in ESG funds in your 401(k)', xstrong: true },
                'will not be enforcing it.'
              )
            ),
            _react2.default.createElement(
              'h3',
              null,
              'Our plan has a self-directed option where employees can access thousands of different funds, including sustainable investments. Is this enough?'
            ),
            _react2.default.createElement(
              'p',
              null,
              'A self-directed option (also called a "brokerage window") can provide more access to sustainable funds. But a self-directed option requires more work from plan participants, and could lead to riskier investments. They\u2019re also seldom used, with ',
              _react2.default.createElement(
                _components.Link,
                { to: 'https://www.investmentnews.com/brokerage-windows-401k-dol-208416', title: 'Seldom-used 401(k) brokerage windows being reviewed by DOL - Investment News', xstrong: true },
                'approximately 2.4% of participants'
              ),
              ' in large and medium-sized 401(k)s using brokerage windows. It\'s better for a retirement plan to offer access to sustainable funds without making people use a self-directed option - or even better, to make the default investment a sustainable fund.'
            ),
            _react2.default.createElement(
              'h3',
              null,
              'What if our asset manager does not have any ESG options available?'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Currently, an estimated $20 trillion AUM, ',
              _react2.default.createElement(
                _components.Link,
                { to: 'https://www.bloomberg.com/professional/blog/esg-assets-may-hit-53-trillion-by-2025-a-third-of-global-aum/', title: 'ESG assets may hit $53 trillion by 2025, a third of global AUM - Bloomberg', xstrong: true },
                'or about a quarter of all actively managed funds,'
              ),
              ' are incorporating ESG into portfolio construction in some way. If your asset manager does not have any appropriate ESG funds, or is not willing to provide them to your company, it may be time to find one that does.'
            ),
            _react2.default.createElement(
              'h3',
              null,
              'We\u2019re ready to make our employee retirement plan sustainability. Are there resources to help us?'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Yes! A great resource for companies seeking to make their retirement plan sustainable is the Forum for Sustainable and Responsible Investment (US-SIF). US-SIF has a ',
              _react2.default.createElement(
                _components.Link,
                { to: 'https://www.ussif.org/education', title: 'Center for Sustainable Investment Education', xstrong: true },
                'Center for Sustainable Investment Education'
              ),
              ' with online and live courses, research publications, and more.'
            )
          )
        ),
        _react2.default.createElement(_components.RiskTypeLinks, null),
        _react2.default.createElement(_components.HomeEduCenter, null)
      );
    }
  }]);
  return EduCenterPlanAdmins;
}(_react.Component)) || _class);
exports.default = EduCenterPlanAdmins;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/EduCenterPlanAdmins/EduCenterPlanAdmins.js
// module id = 1475
// module chunks = 0